import { Card, TableDataRequest } from '@fl/cmsch-fe-library';
import React, { FC, useCallback, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { Opt } from 'ts-opt';
import { StableToChoose } from 'api/gen/StableToChoose';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { StablesTable } from '../components/stables-table';
import { animalBrowserAction, simpleAnimalBrowserSelector } from '../model';
interface DispatchProps {
  getStables(tableDataRequest: Opt<TableDataRequest<StableToChoose>>): void;
}
type Props = DispatchProps;
const FarmsAndStablesBase: FC<Props> = props => {
  const {
    getStables
  } = props;
  const {
    t
  } = useOurTranslation('animalBrowser');
  const title = t('farmsStables');
  const header = useMemo(() => <ConnectedScreenHeader title={title} moduleForTutorials="ANIMALS_BROWSER" />, [title]);
  const dispatch = useDispatch();
  const exportToCsv = useCallback(() => {
    dispatch(animalBrowserAction.getStablesCsv());
  }, [dispatch]);
  const exportInProgress = useSelector(simpleAnimalBrowserSelector.exportInProgress);
  const stablesPageEmpty = useSelector(simpleAnimalBrowserSelector.stablePageEmpty);
  return <Content browserTabTitle={t('breedersBrowser')} data-sentry-element="Content" data-sentry-component="FarmsAndStablesBase" data-sentry-source-file="farms-and-stables.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="farms-and-stables.tsx">
                <StablesTable exportInProgress={exportInProgress} exportDisabled={exportInProgress || stablesPageEmpty} getStables={getStables} exportToCsv={exportToCsv} data-sentry-element="StablesTable" data-sentry-source-file="farms-and-stables.tsx" />
            </Card>
        </Content>;
};
const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  getStables: (tableDataRequest: Opt<TableDataRequest<StableToChoose>>): void => void dispatch(animalBrowserAction.getStablesTableData(tableDataRequest))
});

/**
 * Renders the basic animal-browser landing screen with the farms and stables table.
 *
 * @returns The stable overview screen with CSV export support.
 */
export const FarmsAndStables = connect(null, mapDispatchToProps)(FarmsAndStablesBase);